import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/frames'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { getDeliveryIndicatorConfig } from '../../../configuration'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return <Page {...props} deliveryIndicatorConfig={deliveryIndicatorConfig} />
}

ProductDetailPage.getInitialProps = Page.getInitialProps
export default composePDP<Props>(ProductDetailPage)
